<template>
  <div>
    <div class="w1100 frlinkList">
    	<ul>
        	<li class="marginR10"><a href="http://cpc.people.com.cn/" title="" target="_blank"><img src="/static/images/linkpic1.jpg" width="265" height="48"></a></li>
        	<li class="marginR10"><a href="http://www.12371.cn/" title="" target="_blank"><img src="/static/images/linkpic2.jpg" width="265" height="48"></a></li>
        	<li class="marginR10"><a href="http://www.ahxf.gov.cn/" title="" target="_blank"><img src="/static/images/logo/linkpic3.jpg" width="265" height="48"></a></li>
        	<li><a href="http://www.aqxf.gov.cn/" title="" target="_blank"><img src="/static/images/logo/linkpic4.jpg" width="265" height="48"></a></li>
            <div class="clear"></div>
        </ul>
    </div>
    <div class="w1100 frlinkform">
    	<ul class="marginT10">
            <li class="f16 xl" id="fr1"><a href="javascript:;" onclick="open_zzjs_net(this,'zzjs_net')">全国党建</a>
            	<ul id="zzjs_net" style="display: none;">
                	<li><a href="http://cpc.people.com.cn/" target="_blank">中国共产党新闻网</a></li>
                    <li><a href="http://dangjian.people.com.cn/" target="_blank">党建频道</a></li>
                   
                    <li><a href="http://www.ccps.gov.cn/" target="_blank">中共中央党校</a></li>                   
                    <li><a href="http://dygbjy.12371.cn/" target="_blank">全国党员干部现代远程教育</a></li>
                </ul>
            </li>
            <li class="f16 xl"><a href="javascript:;" onclick="open_zzjs_net(this,'zzjs_net2')">市县先锋</a>
            	<ul id="zzjs_net2" style="display:none">
                    <li><a href="http://www.tcxf.gov.cn/" target="_blank">桐城</a></li>
                    <li><a href="http://zzb.ahhn.gov.cn/" target="_blank">怀宁</a></li>
                    <li><a href="http://www.qsxf.gov.cn/" target="_blank">潜山</a></li>
                    <li><a href="http://www.yxxf.gov.cn/" target="_blank">岳西</a></li>
                    <li><a href="http://www.thxf.gov.cn/" target="_blank">太湖</a></li>
                    <li><a href="http://www.wjxf.gov.cn/" target="_blank">望江</a></li>
                    <li><a href="http://www.ssxf.gov.cn/" target="_blank">宿松</a></li>
                    <li><a href="http://www.yjqxfw.gov.cn/" target="_blank">迎江</a></li>
                    <li><a href="http://www.aqdgzzb.gov.cn/" target="_blank">大观</a></li>
                    <li><a href="http://www.yxqxfw.gov.cn/" target="_blank">宜秀</a></li>
                   
                </ul>
            </li>
            <li class="f16 xl"><a href="javascript:;" onclick="open_zzjs_net(this,'zzjs_net3')">新闻媒体</a>
            	<ul id="zzjs_net3" style="display:none">
                	<li><a href="http://www.xinhuanet.com/" target="_blank">新华网</a></li>
                    <li><a href="http://www.people.com.cn/" target="_blank">人民网</a></li>
                    <li><a href="http://www.chinanews.com/" target="_blank">中国新闻网</a></li>
                    <li><a href="http://www.ah.gov.cn/" target="_blank">安徽政府网</a></li>
                    <li><a href="http://www.anhuinews.com/" target="_blank">中安在线</a></li>                   
                </ul>
            </li>
            <li class="f16 xl" style="border-right:1px solid #E0E0E0;"><a href="javascript:;" onclick="open_zzjs_net(this,'zzjs_net4')">市内网站</a>
            	<ul id="zzjs_net4" style="display:none">
                	<li><a href="http://www.qsxw.gov.cn/" target="_blank">潜山新闻网</a></li>
					        <li><a href="http://www.ahqsjjw.gov.cn/" target="_blank">潜山纪检监察网</a></li>	
					        <li><a href="https://www.qss.gov.cn/qssrsj/index.html" target="_blank">潜山人社局</a></li>	
              </ul>
            </li>
            <div class="clear"></div>
        </ul>
    </div>


    <div class="w1100 f14" style="border-top:2px solid #F60100; margin-top:10px; text-align:center; line-height:29px; padding:15px 0">
      <!-- 建议：使用IE9以上版本的软件、1024×768显示模式浏览网站，将获得较好的效果<br> -->
      主办单位：中共潜山市委组织部 &nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备20007436号-1</a>
      <img src="data:image/png;base64,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" style="vertical-align:-5px">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34082402000402" target="_blank">皖公网安备34082402000402号</a>
      <br>
      技术支持：中国移动通信集团有限公司（China Mobile Communications Group Co.,Ltd&nbsp;）<br>
      编辑部电话：0556-8921401 Email：qsxfw@sina.com<br>
    </div>

  </div>
</template>


<script>

import  '../assets/css/css.css'

export default {
  name: 'FooterIndex',
  data () {
    return {
      
    }
  },
  mounted() {
      window['open_zzjs_net'] = (oSourceObj,oTargetObj,shutAble,oOpenTip,oShutTi) => {
        this.init(oSourceObj,oTargetObj,shutAble,oOpenTip,oShutTi);
     }
  },
  methods: {
      init:function open_zzjs_net(oSourceObj,oTargetObj,shutAble,oOpenTip,oShutTip){
            var sourceObj = typeof oSourceObj == "string" ? document.getElementById(oSourceObj) : oSourceObj;
            var targetObj = typeof oTargetObj == "string" ? document.getElementById(oTargetObj) : oTargetObj;
            var openTip = oOpenTip || "";
            var shutTip = oShutTip || "";
            if(targetObj.style.display!="none"){
              if(shutAble) return;
              targetObj.style.display="none";
              if(openTip  &&  shutTip){
                sourceObj.innerHTML = shutTip;
              }
            } else {
              targetObj.style.display="block";
              if(openTip  &&  shutTip){
                sourceObj.innerHTML = openTip;
              }
            }
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/FooterIndex.vue